import React from 'react';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';
import { useOnboardingJourney } from '../../Data/Onboarding';
import { PageLoading } from '../../Components/Loading';
import Section, { Sections } from '../../Components/Containers/Section';
import nl2br from 'react-nl2br';
import ButtonRow from '../../Components/Button/ButtonRow';
import Button from '../../Components/Button/Button';
import { useDialogues } from '../../Components/Dialogues';
import Icon from '../../Components/Icons/TheIcon';

const ignoredSteps = [
    'PricingCategories',
];

const Checklist = () => {
    const {journey, markStepDone, markStepSkipped, isSaving} = useOnboardingJourney();

    return <>
        <TopBar left="BackBtn" title="Checklist" />
        <Page>
            {journey ? <Inner {...{journey, markStepDone, markStepSkipped, isSaving}} /> : <PageLoading />}
        </Page>
    </>
}

const Inner = ({journey, markStepDone, markStepSkipped, isSaving}) => {
    // New, Started, Completed, Skipped, Blocked, Unavailable

    const sorted = journey.steps.filter(s => !ignoredSteps.includes(s.key)).sort((a, b) => b.priority - a.priority);
    const available = sorted.filter(step => ['New', 'Started'].indexOf(step.status) > -1);
    // const available = [];

    // const blocked = sorted.filter(step => step.status === 'Blocked');
    // const completed = sorted.filter(step => step.status === 'Completed');
    // const skipped = sorted.filter(step => step.status === 'Skipped');
    // const unavailable = sorted.filter(step => step.status === 'Unavailable');

    if (available.length === 0) {
        return <div className="my-5 text-center">
            <Icon icon="PartyHorn" size="4x" className="my-2 fill-brand" />
            <p className="my-2 font-bold">
                All done!
            </p>
            <p className="my-2 text-muted text-balance">
                You have completed all the steps in your checklist.
            </p>
            <p className="my-2 text-muted text-balance">
                Great job!
            </p>
        </div>
    }

    return <Sections className="w-full" divider>
        {available.map(step => {
            return <Card key={step.id} {...{step, markStepDone, markStepSkipped, isSaving}} />
        })}
    </Sections>
}

const Card = ({step, markStepDone, markStepSkipped, isSaving}) => {
    const {confirm} = useDialogues();
    const {key, title, description, link, canBeSkipped, canBeMarkedDone} = step;

    return <Section title={title}>
        <div className="prose prose-slate prose-sm">
            <p>{nl2br(description)}</p>
        </div>
        <ButtonRow>
            <Button theme="light"
                hide={!canBeSkipped}
                label="Skip"
                onClick={() => confirm(
                    {
                        theme: 'primary',
                        title: 'Temporarily skip this item',
                        confirmLabel: 'Skip',
                        message: `Are you sure you want to skip this item? It will no longer show in your getting started checklist.

                        Skipped items might reappear when we update the items or you make changes in your account.`,
                    },
                    () => markStepSkipped(key)
                )}
                onClickLoading
            />
            <Button theme="light"
                hide={!canBeMarkedDone}
                label="Done"
                onClick={() => confirm(
                    {
                        theme: 'primary',
                        title: 'Mark this item as done',
                        confirmLabel: 'Done',
                        message: `Once you mark an item as done you can't undo it. Are you sure you have completed this item?`,
                    },
                    () => markStepDone(key)
                )}
                onClickLoading
            />
            <Button theme="primary"
                hide={!link}
                label="Go"
                link={link}
            />
        </ButtonRow>
    </Section>
}


export default Checklist;